import { Environment } from './environment.model';

export const environment: Environment = {
    production: false,
    app: {
        title: 'ErP-Label',
    },
    instana: true,
    statusPage: 'https://api-integration.viessmann-climatesolutions.com/status/v1/apps/y3y4j2l8tqqg/summary',
    auth: {
        appId: 'energy-label',
        baseUrl: 'https://api-integration.viessmann-climatesolutions.com',
        registerBaseUrl: 'https://account-integration.viessmann-climatesolutions.com',
    },
    apiUrl: 'https://api-integration.viessmann-climatesolutions.com',
    translations: {
        app: 'https://api-integration.viessmann-climatesolutions.com/translations/v2/phraseapp-proxy/projects/89e6404bb2ed22771540cfa66647a3d5/locales/',
        dsw: 'https://api-integration.viessmann-climatesolutions.com/translations/v2/phraseapp-proxy/projects/ec38b083a23c58c604a49d7f443dd7f2/locales/',
    },
};
